/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 09:21:28
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { getRemove, getTAHManagementDetail, getTAHManagementList, getTAHManagementSubmit, SubmitParams, TAHManagementListParams, DetailParams } from "../../../services/TAHManagement";

// 列表
export const getTAHManagementListAsync = createAsyncThunk<
  void,
  TAHManagementListParams,
  RootThunkApi<void>
>('TAHManagement/getTAHManagementListAsync', async (params, api) => {
  return sendAsync(getTAHManagementList(params), api)
})


// 详情
export const getTAHManagementDetailAsync = createAsyncThunk<void, DetailParams, RootThunkApi<void>>(
  'TAHManagement/getTAHManagementDetailAsync',
  async (params, api) => {
    return sendAsync(getTAHManagementDetail(params), api)
  }
)


// 保存编辑
export const getTAHManagementSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'TAHManagement/getTAHManagementSubmitAsync',
  async (params, api) => {
    return sendAsync(getTAHManagementSubmit(params), api)
  }
)


// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'TAHManagement/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
